import chooseCompanyApi from "./modules/choose_company_api";
import loginApi from "./modules/login_api";
import userAccountApi from "./modules/user_manage/user_account";
import userGroupApi from "./modules/user_manage/user_group";
import userPermissionApi from "./modules/user_manage/user_permission";
import aPoolAllocationApi from "./modules/number_pool_api/a_pool/apool_allocation"
import aNumberManageApi from "./modules/number_pool_api/a_pool/a_number_manage"
import MyApplicationApi from "./modules/number_pool_api/x_pool/my_application"
import xPoolAllocationApi from "./modules/number_pool_api/x_pool/xpool_allocation"
import xNumberManageApi from "./modules/number_pool_api/x_pool/x_number_manage"
import videoListApi from "./modules/video_manage/video_list"
import templateApi from "./modules/call_card/template_api"
import signatureApi from "./modules/call_card/signature_api"
import taskApi from './modules/call_out/task_manage'
import languageApi from './modules/call_out/language_manage'
import callManageApi from './modules/call_out/call_manage'
import recordingManageApi from './modules/recording_manage/recording_manage'
import scriptLanguageApi from './modules/script_manage/language_api'

const api={
    loginApi,
    chooseCompanyApi,
    userAccountApi,
    userGroupApi,
    userPermissionApi,
    aPoolAllocationApi,
    aNumberManageApi,
    MyApplicationApi,
    xPoolAllocationApi,
    xNumberManageApi,
    videoListApi,
    templateApi,
    signatureApi,
    taskApi,
    languageApi,
    callManageApi,
    recordingManageApi,
    scriptLanguageApi
}
export default api
